export default __webpack_public_path__ + "static/media/background.bb33c30e.jpg";